import React, { PropsWithChildren } from 'react';
import Grid from '@mui/material/Grid';

import { CourseInfoBannerMain, CourseInfoHeader, CourseInfoItem } from './elements';

interface CourseInfoBannerProps {
  duration: string | null;
  benefits: {
    url: string | null;
    text: string | null;
    size: string | null;
  }[];
}

const insertHours = (text: string, courseDuration: string | null) =>
  // eslint-disable-next-line no-template-curly-in-string
  text.replace('${hours}', courseDuration?.replace(/[^0-9.]/g, '') || '');

const sizeImage = (url: string | null) => {
  if (!url) return {};
  const fileFormat = url.split('.').pop();
  return fileFormat === 'svg' ? { height: 35, width: 35 } : { width: 35 };
};

export const CourseInfoBanner: React.FC<PropsWithChildren<CourseInfoBannerProps>> = ({
  benefits,
  duration,
}) => {
  return (
    <CourseInfoBannerMain>
      <Grid container justifyContent="center" alignItems="center">
        {benefits.map(benefit => (
          <Grid key={benefit.url} item xs={12} lg={3}>
            <CourseInfoItem>
              <img src={benefit.url || ''} style={sizeImage(benefit.url)} />
              <CourseInfoHeader>{insertHours(benefit.text || '', duration)}</CourseInfoHeader>
            </CourseInfoItem>
          </Grid>
        ))}
      </Grid>
    </CourseInfoBannerMain>
  );
};
